import moment from 'moment'
import { chunk } from 'lodash'

const createNumericArray = (length) => Array.from(Array(length).keys())

const getWeeksArrays = (date) => {
    date = moment(date)
    const daysInMonth = date.daysInMonth()
    const startOfWeek = moment([date.year(), date.month(), 1]).day()
    //  Create array of days
    let days = createNumericArray(daysInMonth + 1).slice(1)
    //  Unshift the starting days
    if (startOfWeek) {
        createNumericArray(startOfWeek).forEach( () => days.unshift(0))
    }
    

    //  slice up into weeks
    const weeks = chunk(days, 7)

    //  Check to be sure the last week is filled
    const lastWeek = weeks[weeks.length - 1]
    const lastWeekLength = lastWeek.length
    if (lastWeekLength < 7) {
        createNumericArray(7 - lastWeekLength).forEach(() => lastWeek.push(0))
    }

    return weeks
}

export default getWeeksArrays